import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import TotalUsers from "../../../../images/icons/total-users.svg";
import { calculateTotalUsers } from './Services/reportTimeWorked';

// Functional component
function TimeWorkedTotalUsers({ trackReport }) {
  const [displayedCount, setDisplayedCount] = useState(0);
  const [targetCount, setTargetCount] = useState(0);
  const animationFrameRef = useRef(null);
  const reportingTimeWorked = useSelector((state) => state.reportingTimeWorked);

  useEffect(() => {
    if (trackReport && Array.isArray(trackReport) && reportingTimeWorked) {
      const totalUsersTracked = calculateTotalUsers(trackReport, reportingTimeWorked);
      setTargetCount(totalUsersTracked || 0);
    } else {
      setTargetCount(0);
    }
  }, [trackReport, reportingTimeWorked]);

  useEffect(() => {
    // Cancel any existing animation
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
    }

    const startValue = displayedCount;
    const endValue = targetCount;
    const duration = 1000; // Animation duration in milliseconds
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Easing function for smooth animation (ease-out)
      const easeOut = 1 - Math.pow(1 - progress, 3);
      
      const currentValue = startValue + (endValue - startValue) * easeOut;
      setDisplayedCount(Math.floor(currentValue));

      if (progress < 1) {
        animationFrameRef.current = requestAnimationFrame(animate);
      } else {
        setDisplayedCount(endValue);
        animationFrameRef.current = null;
      }
    };

    if (Math.abs(startValue - endValue) > 0.01) {
      animationFrameRef.current = requestAnimationFrame(animate);
    }

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [targetCount]);

  return (
    <div>
      <div className="overview-item">
        <div className="overview-title-outer">
          <div className="overview-title">Total Users</div>
          <div className="overview-icon">
            <img src={TotalUsers} alt="cLock" />
          </div>
        </div>

        <div className="overview-rice">
          {displayedCount}
        </div>
      </div>
    </div>
  );
}

export default TimeWorkedTotalUsers;
